import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=9b34045c&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"
import style0 from "./Footer.vue?vue&type=style&index=0&id=9b34045c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b34045c",
  null
  
)

export default component.exports